import { HIRAGANA_SETS, KATAKANA_SETS } from './kana'

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function getTimeSpan(start = 0, end = 0) {
  // get total seconds between the times
  let delta = Math.abs(end - start) / 1000

  // calculate (and subtract) whole days
  const days = Math.floor(delta / 86400)
  delta -= days * 86400

  // calculate (and subtract) whole hours
  const hours = Math.floor(delta / 3600) % 24
  delta -= hours * 3600

  // calculate (and subtract) whole minutes
  const minutes = Math.floor(delta / 60) % 60
  delta -= minutes * 60

  // what's left is seconds
  const seconds = (delta % 60).toFixed(2)

  return { hours, minutes, seconds }
}

export function getAllKanaFromSets(sets) {
  let allChars = []

  for (let index = 0; index < sets.length; index++) {
    const element = sets[index]
    if (element.includes('hir')) {
      allChars.push(...HIRAGANA_SETS[element])
    }
    if (element.includes('kat')) {
      allChars.push(...KATAKANA_SETS[element])
    }
  }
  return allChars
}

export function kanaPracticeReducer(state, { type, payload }) {
  switch (type) {
    case 'FLIP':
      return {
        ...state,
        cardSide: 'answer',
        streak: 0,
      }
    case 'CHOOSE_FIRST_KANA':
      const hiragana =
        payload.availableKana[randomInt(0, payload.availableKana.length - 1)]
      return {
        ...state,
        currentKana: hiragana,
        history: [],
        finishedRun: false,
        streak: 0,
        inputValue: '',
        startTime: null,
        endTime: null,
      }
    case 'INPUT_CHANGE':
      return { ...state, inputValue: payload.inputValue }
    case 'ENTER_WRONG':
      return {
        ...state,
        answered: 'wrong',
        streak: 0,
        missed: state.missed + 1,
      }
    case 'ENTER_CORRECT':
      const kanaFiltered = payload.availableKana.filter((hiragana) => {
        return (
          hiragana[0] !== state.currentKana[0] &&
          state.history.find((hiraganaInHistory) => {
            return hiraganaInHistory.includes(hiragana[0])
          }) == null
        )
      })

      let nextKana
      let finishedRun = false

      if (kanaFiltered.length === 0) {
        if (payload.mode === 'infinite') {
          nextKana =
            payload.availableKana[
              randomInt(0, payload.availableKana.length - 1)
            ]
        } else {
          nextKana = undefined
          finishedRun = true
        }
      } else {
        nextKana = kanaFiltered[randomInt(0, kanaFiltered.length - 1)]
      }

      return {
        ...state,
        inputValue: '',
        answered: 'correct',
        streak: state.streak + 1,
        currentKana: nextKana,
        history: state.history.concat([state.currentKana]),
        finishedRun,
        startTime: state.startTime == null ? new Date() : state.startTime,
        endTime: finishedRun ? new Date() : state.endTime,
      }

    case 'NEXT_KANA':
      const kanaFiltered2 = payload.availableKana.filter(
        (hiragana) =>
          state.history.find((hiraganaInHistory) =>
            hiraganaInHistory.includes(hiragana[0])
          ) == null
      )
      let nextKana2
      let finishedRun2 = false

      if (kanaFiltered2.length === 0) {
        if (payload.mode === 'infinite') {
          nextKana2 =
            payload.availableKana[
              randomInt(0, payload.availableKana.length - 1)
            ]
        } else {
          nextKana2 = undefined
          finishedRun2 = true
        }
      } else {
        nextKana2 = kanaFiltered2[randomInt(0, kanaFiltered2.length - 1)]
      }

      return {
        ...state,
        inputValue: '',
        answered: 'no',
        cardSide: 'question',
        streak: 0,
        missed: state.missed + 1,
        currentKana: nextKana2,
        finishedRun: finishedRun2,
        startTime: state.startTime == null ? new Date() : state.startTime,
      }

    default:
      return state
  }
}

export function romajiPracticeReducer(state, { type, payload }) {
  switch (type) {
    case 'FLIP':
      return {
        ...state,
        cardSide: state.cardSide === 'answer' ? 'question' : 'answer',
      }
    case 'CHOOSE_FIRST_KANA':
      const kana =
        payload.availableKana[randomInt(0, payload.availableKana.length - 1)]
      return {
        ...state,
        currentKana: kana,
        history: [],
        finishedRun: false,
        streak: 0,
        inputValue: '',
        startTime: null,
        endTime: null,
      }
    case 'ENTER_CORRECT':
      const kanaFiltered = payload.availableKana.filter((hiragana) => {
        return (
          hiragana[0] !== state.currentKana[0] &&
          state.history.find((hiraganaInHistory) => {
            return hiraganaInHistory.includes(hiragana[0])
          }) == null
        )
      })

      let nextKana
      let finishedRun = false

      if (kanaFiltered.length === 0) {
        if (payload.mode === 'infinite') {
          nextKana =
            payload.availableKana[
              randomInt(0, payload.availableKana.length - 1)
            ]
        } else {
          nextKana = undefined
          finishedRun = true
        }
      } else {
        nextKana = kanaFiltered[randomInt(0, kanaFiltered.length - 1)]
      }

      return {
        ...state,
        inputValue: '',
        answered: 'correct',
        streak: state.streak + 1,
        currentKana: nextKana,
        cardSide: 'question',
        history: state.history.concat([state.currentKana]),
        finishedRun,
        startTime: state.startTime == null ? new Date() : state.startTime,
        endTime: finishedRun ? new Date() : state.endTime,
      }

    case 'NEXT_KANA':
      const kanaFiltered2 = payload.availableKana.filter(
        (kana) =>
          state.history.find((kanaInHistory) =>
            kanaInHistory.includes(kana[0])
          ) == null
      )
      let nextKana2
      let finishedRun2 = false

      if (kanaFiltered2.length === 0) {
        if (payload.mode === 'infinite') {
          nextKana2 =
            payload.availableKana[
              randomInt(0, payload.availableKana.length - 1)
            ]
        } else {
          nextKana2 = undefined
          finishedRun2 = true
        }
      } else {
        nextKana2 = kanaFiltered2[randomInt(0, kanaFiltered2.length - 1)]
      }

      return {
        ...state,
        inputValue: '',
        answered: 'no',
        cardSide: 'question',
        streak: 0,
        missed: state.missed + 1,
        currentKana: nextKana2,
        finishedRun: finishedRun2,
        startTime: state.startTime == null ? new Date() : state.startTime,
      }

    default:
      return state
  }
}
